import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { SessionService } from './../services/session.service';
import { User } from './user.service';
import { Router } from '@angular/router';

const API_URL = environment.apiUrl

interface RefreshTokenResponse {
  user: User
  token: string
  refreshToken: string
}

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private http: HttpClient, private sessionService: SessionService, private router: Router) { }

  login(user) {
    const headers = new HttpHeaders({ 'No-Auth': 'true' });
    headers.append('Content-Type', 'application/json');

    return this.http
      .post<any>(`${API_URL}/login/`, user, { headers: headers });
  }

  async getNewCredentialsWithRefreshToken() {
    const { refreshToken, token } = this.sessionService.currentUserValue

    const headers = new HttpHeaders({ 'No-Auth': 'true', 'api-token': token });
    headers.append('Content-Type', 'application/json');

    return this.http
      .post<RefreshTokenResponse>(`${API_URL}/refresh-token`, { refreshToken }, { headers: headers }).toPromise();
  }

  async logout(invalidateCredentials = true) {
    const { refreshToken } = this.sessionService.currentUserValue

    if(invalidateCredentials) await this.http.post(`${API_URL}/logout`, { refreshToken }).toPromise()

    this.sessionService.removeSession();

    this.router.navigate(['/login']);
  }
}
